@use "@fukuri-admins/ui/layout" as *;

.contactWrapper {
  display: flex;
  flex-direction: column;
  gap: spacing('16');

  .title {
    @include typography('Jp/14_W6');
  }

  .subTitle {
    @include typography('Jp/24_W6');
  }

  .card {
    border: 1px solid border('Gray_Darken');
    border-radius: borderRadius('lg');
    padding: spacing('16');
    width: 48%;
  }

  .contentWrapper {
    display: flex;
    justify-content: space-between;
    margin-top: spacing('8');

    .contentText {
      @include typography('Jp/20_W6');
    }

    .textCenter {
      text-align: center;
    }

    .contentDescription {
      margin: spacing('16') 0 spacing('32');
    }

    // 受付時間は電話番号より小さく見せる（font-size: 14px / line-height: 22px / font-weight: 600 / letter-spacing: 0.02em）
    .receptionTime {
      @include typography('Jp/14_W6');
    }
  }
}
